import { customInstance } from 'lib/api-instance'

export type WritingHomeRedirectResponse = {
  redirectTo: string | null
}

type ResponseSuccess<T> = {
  data: T
  status: number
  headers: Headers
}

export const getWritingHomeRedirect = async (
  options?: RequestInit
): Promise<ResponseSuccess<WritingHomeRedirectResponse>> => {
  return customInstance<ResponseSuccess<WritingHomeRedirectResponse>>(
    '/api-arvore/writing/profile/home-redirect',
    {
      ...options,
      method: 'GET'
    }
  )
}
